import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';

import {
  ActionIcons,
  ButtonItem,
  ActionContainerComponent,
} from '@modules/ui/action-container/action-container.component';

import { ImageComponent } from '../../media/image/image.component';
import { CardBaseComponent } from '../card-base/card-base.component';
import { TestCarModel } from '../models/test-car.model';

@Component({
  selector: 'mb-test-car-card',
  templateUrl: './test-car-card.component.html',
  styleUrls: ['./test-car-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CardBaseComponent, ImageComponent, ActionContainerComponent],
})
export class TestCarCardComponent {
  @Input() data!: TestCarModel;
  @Input() actions: ButtonItem[] = [
    {
      icon: ActionIcons.DOWNLOAD,
      class: 'btn btn-plain',
    },
  ];
  @Output() actionClick = new EventEmitter<ActionIcons>();
}
